import { useI18n } from 'builder/hooks/useI18n'
import { LOCALIZATION_KEY } from '../../constants'
import { Container, Text, IconContainer, Icon } from './styles'

export const AvailableCountriesBanner = () => {
  const { i18n } = useI18n()

  return (
    <Container>
      <IconContainer>
        <Icon />
      </IconContainer>
      <Text
        dangerouslySetInnerHTML={{
          __html: i18n.t(`${LOCALIZATION_KEY}.available_countries_banner`),
        }}
      />
    </Container>
  )
}
